import { EmailValidationError } from 'errors/EmailValidationError';
import { validateEmail } from 'api/account';
import { getErrors } from 'api/client';

export const validateEmailThunk = (email, slice) => async (dispatch) => {
  const {
    actions: { setIsLoading, setSuccess, setError }
  } = slice;

  try {
    dispatch(setIsLoading());
    const response = await validateEmail(email);
    const isValidEmail = ['unknown', 'accept_all', 'valid'].includes(
      response.status
    );

    if (!isValidEmail) {
      const error = new EmailValidationError();
      const errors = [error.toJson()];

      dispatch(setError(errors));
      return Promise.reject(errors);
    }

    dispatch(setSuccess(response));
    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};

export const useValidateEmailThunk = (slice) => {
  return (email) => validateEmailThunk(email, slice);
};
